// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__HswBA","icon":"styles_icon__Ur1TW","link":"styles_link__WYnBp","active":"styles_active__RcNKa"};